import { calculateMonthsDiff } from "./calculateMonthsDiff";
import {
  MAX_LOAN_TERM,
  MAX_LOAN_TERM_FACILITEA,
} from "./downPaymentCalculation";

export const getMaxTermByAutoRegistrationDate = (
  autoRegistrationDate,
  maxTermByLoanCalculator,
  isFaciliteaAgent
) => {
  if (!autoRegistrationDate) return maxTermByLoanCalculator;
  const registrationDateInMonths = calculateMonthsDiff(
    new Date(autoRegistrationDate),
    new Date()
  );

  const maxAllowedTermByRegistrationDate =
    (isFaciliteaAgent ? MAX_LOAN_TERM_FACILITEA : MAX_LOAN_TERM) -
    registrationDateInMonths;

  return maxAllowedTermByRegistrationDate > maxTermByLoanCalculator
    ? maxTermByLoanCalculator
    : maxAllowedTermByRegistrationDate;
};
